import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart3"><Path d="M20.9999 3H15.6699V21H20.9999V3Z" fill="currentColor"/><Path d="M14.6601 8.33398H9.33008V21.0007H14.6601V8.33398Z" fill="currentColor"/><Path d="M8.33 12.7773H3V20.9996H8.33V12.7773Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart3;
